<template>
  <div class="page">
    <a name="corporate"/>
    <br>
    <br>
    <div class="columns">
      <div class="column is-half">
        <p class="dustin preheader">
          Asset Class -- Corporate
        </p>
        <p class="dustin-title ">
          Aggregate Impact
        </p>
        <br>
        <p class="preheader">
          MSCI Ratings
        </p>
        <p class="description">
          Methodology
        </p>
        <p class="criteria">
          Each fund or ETF scores a rating on a scale from CCC (laggard) to AAA (leader). The rating is based first on the weighted average score of the holdings of the fund or ETF. We then assess ESG momentum to gain insight into the fund’s ESG track record, which is designed to indicate a fund’s exposure to holdings with a positive rating trend or worsening trend year over year. Finally, we review the ESG tail risk to understand the fund’s exposure to holdings with worst-of-class ESG Ratings of B and CCC.
        </p>
      </div>
  
      <div class="column is-half">
        <div class="box"><!-- MSCI Box -->
        
          <div class="columns is-vcentered">
            <div class="column is-two-thirds">
              <p class="title is-1">
                MSCI
              </p>
              <p class="subtitle is-allcaps">
                ESG RATINGS
              </p>
            </div>
            <div class="column is-one-third has-text-centered">
              <p class="msci-circle">
                {{realScore}}
              </p>
            </div>
          </div>
             <div class="columns is-vcentered has-text-centered">
            <div class="column is-1">
              <p class="heading is-size-5">E</p>
            </div>
            <div class="column is-9">
              <progress class="progress is-success" :value="esgScores[1]" max="10"></progress>
            </div>
            <div class="column is-2">
              <p class="heading is-size-5">{{esgScores[1]}}</p>
            </div>
          </div>
          <div class="columns is-vcentered has-text-centered">
            <div class="column is-1">
              <p class="heading is-size-5">S</p>
            </div>
            <div class="column is-9">
              <progress class="progress is-warning" :value="esgScores[2]" max="10"></progress>
            </div>
            <div class="column is-2">
              <p class="heading is-size-5">{{esgScores[2]}}</p>
            </div>
          </div>
          <div class="columns is-vcentered has-text-centered">
            <div class="column is-1">
              <p class="heading is-size-5">G</p>
            </div>
            <div class="column is-9">
              <progress class="progress is-link" :value="esgScores[0]" max="10"></progress>
            </div>
            <div class="column is-2">
              <p class="heading is-size-5">{{esgScores[0]}}</p>
            </div>
          </div>
          <hr>
          

          <div class="tabs is-toggle is-fullwidth is-small">
            <ul>
              <li :class="[realScore == 'CCC'?'is-active':'']">
                <a>
                  <span>CCC</span>
                </a>
              </li>
              <li :class="[realScore == 'B'?'is-active':'']">
                <a>
                  <span>B</span>
                </a>
              </li>
              <li :class="[realScore == 'BB'?'is-active':'']">
                <a>
                  <span>BB</span>
                </a>
              </li>
              <li :class="[realScore == 'BBB'?'is-active':'']">
                <a>
                  <span>BBB</span>
                </a>
              </li>
              <li :class="[realScore == 'A'?'is-active':'']">
                <a>
                  <span>A</span>
                </a>
              </li>
              <li :class="[realScore == 'AA'?'is-active':'']">
                <a>
                  <span>AA</span>
                </a>
              </li>
              <li :class="[realScore == 'AAA'?'is-active':'']">
                <a>
                  <span>AAA</span>
                </a>
              </li>
            </ul>
          </div>
        </div><!-- box -->
      </div><!-- half column -->
    </div>
    <div class="columns">
      <div class="column is-half">
        <p class="preheader">
          Benchmark Comparison
        </p>
        <p class="description">
          Methodology
        </p>
        <p class="criteria">
          Impact data about corporations is collected from over 100 publicly available sources and grouped together into five main categories -- Environment, Human Rights, Equal Opportunity, Health, and Accountability.

          Overall aggregations by issue area are a coverage-weighted average of each metric's comparison between the portfolio and {{ benchmark.name ? benchmark.name : 'the benchmark' }}.

          For portfolios that include funds, managers' shareholder engagement activities are included in the overall comparisons for each of the 5 major issue areas if at least three companies have improved, or committed to improve disclosure or performance in that issue area following shareholder engagement by the fund managers in your portfolio over the last two years.
        </p>
      </div>
      <div class="column is-half">
        
        <div class="graphic">

        <div class="verticalline adjust-pixels-left" v-bind:style="`height: ${30 + (50 * Object.keys(reportMetricsByEsgIssue).length)}px`"></div>
        <!--
          FOR THIS STYLE WE SHOULD CHANGE THE COMPUTATION TO BE % RELATIVE TO BENCHMARK RATHER THAN PERCENTILE PRGORESS
        -->


            



            <template v-for="(metricList, slug) in reportMetricsByEsgIssue">
              <span v-bind:class="`icon is-large has-text-${metricList[0].details.subcategory[0].esgissue.slug}`">
                <i v-bind:class="`${metricList[0].details.subcategory[0].esgissue.icon} fa-2x`"></i>
              </span>

              <span class="criteria esgissue-label-inner-text">&nbsp;&nbsp;  {{ metricList[0].details.subcategory[0].esgissue.name }}</span>
              <div
                v-bind:class="`shape rectangle ${slug}-bar opacity`"
                v-bind:style="getPxForPct(portfolio.msci_report.report.overall_benchmark_comparison[slug], false)"
              >
              </div>
              <div
                v-if="portfolio.msci_report.report.overall_benchmark_comparison[slug] > 50"
                v-bind:style="getPxForPct(portfolio.msci_report.report.overall_benchmark_comparison[slug], true)"
                v-bind:class="`shape rectangle ${slug}-bar`">
              </div>
              <span class="verticaltext is-size-7" v-bind:style="getChartPctMargin(portfolio.msci_report.report.overall_benchmark_comparison[slug], slug)">
                {{ portfolio.msci_report.report.overall_benchmark_comparison[slug] > 50 ? '+' : ''}}
                {{ Math.round((portfolio.msci_report.report.overall_benchmark_comparison[slug] - 50) * 2) }}%
                <!-- {{ portfolio.msci_report.report.overall_benchmark_comparison[slug] }} -->
              </span>
              <br>
            </template>
          <br>
          <p class="has-text-centered dustin-label">{{ benchmark.name ? 'Compared to: ' + benchmark.name : 'Blended Benchmark' }}</p>
      </div>
      </div>
    </div><!-- columns -->


      <p class='preheader'>
        Benchmark Comparison
      </p>
      <p class="criteria">
        The particular issue areas for your report are filtered based on your impact objectives. The displayed comparisons are based on a dollar-weighted average based on the portfolio constituents with data coverage for each metric. For example, 30% less animal exploitation (-30%) means that, as a dollar-weighted average, 30% fewer constituents in the selected portfolio have ties to animal testing and animal food products, compared to their respective benchmarks. Funds are assigned a value for each metric based on a dollar-weighted average of the companies held by that fund with data coverage for that metric.
      </p>
<br>

<!-- header-->

  <div class="columns is-centered">
    <!-- column with information about metrics -->
    <div class="column is-half">
      <!-- blank in the header -->
      &nbsp;
    </div>
    <!-- column with infomation about portfolio a -->
    <div class="column nopadding is-one-quarter has-text-centered">
      <p class="preheader">
        {{ portfolio.name }}
      </p>
    </div>
    <!-- column with infomation about portfolio b -->
    <div class="column nopadding is-one-quarter has-text-centered">
      <p class="preheader">
        {{ benchmark.name ? benchmark.name : 'Blended Benchmark' }}
      </p>
    </div>
  </div><!-- columns-->


<!-- main page -->

  <section
    class="section metric-section"
    v-for="(metricList, slug) in reportMetricsByEsgIssue"
    v-bind:key="slug"
  >
      <!-- for loop here -- iterate over all the metrics and create a columns node for each metric -->
      <div class="columns is-centered is-vcentered print-no-break">
        <!-- metric description -->
          <div class="column is-half">
            <div class="columns" style="margin-left:-3rem;">
              <div class="column is-narrow">
                <span v-bind:class="`icon has-text-${metricList[0].esgissue_slug}`">
                  <i v-bind:class="`${metricList[0].details.subcategory[0].esgissue.icon} fa-lg`"></i>
                </span>
              </div>
              <div class="column has-text-left">
                <h3 class="preheader">
                  {{ metricList[0].details.subcategory[0].esgissue.name }}
                </h3>
              </div>
            </div>
          </div>

          <!-- left side portfolio a -->
          <div class="column nopadding is-one-quarter has-text-right">
              <div v-if="portfolio.msci_report.report.overall_benchmark_comparison[slug] > 50" class="barbox barbox-left">
                <div>&nbsp;&nbsp;</div>
                <div v-bind:style="{visibility: 'hidden', width: (portfolio.msci_report.report.overall_benchmark_comparison[slug] - 50/100) * 90, height: 340}" v-bind:class="`rectangle ${metricList[0].esgissue_slug}-bar`"></div>
              </div>
          </div>

          <!-- right side portfolio b -->

          <div class="column nopadding is-one-quarter has-text-left">
            <div class="verticalline"></div>
            <div class="barbox barbox-right" v-if="portfolio.msci_report.report.overall_benchmark_comparison[slug] <= 50">
              <div v-bind:style="{visibility: 'hidden', width: (portfolio.msci_report.report.overall_benchmark_comparison[slug] - 50/100) * 90, height: 340}" v-bind:class="`rectangle ${metricList[0].esgissue_slug}-bar`"></div>
            </div>
          </div>
      </div><!-- columns for each metric-->


          <!-- for loop here -- iterate over all the metrics and create a columns node for each metric -->
        <div
          v-for="(metric, index) in metricList"
          v-bind:key="`${metric.id}-${index}`"
          class="columns is-centered is-vcentered print-no-break"
        >

          <!-- metric description -->
          <div class="column is-half">
            <h3 class="dustin-label">
              {{ metric.name }}
            </h3>
            <p class="dustin criteria">
              {{ metric.description }}
            </p>
          </div>

          <!-- left side portfolio a -->
          <div class="column nopadding is-one-quarter ">
              <a
                v-if="metric.better_than_benchmark"
                target="_blank" rel="noreferrer noopener"
                v-bind:href="`/impact-report-attribution/${metric.attribution_id}/${portfolio.slug}${benchmark.name ? ':' + benchmark.slug : ''}`"
              >
                <div class="barbox barbox-left">
                  <div>
                    <h3 class="dustin preheader dontstandso smaller-line-height">
                      {{ metric.relative_benchmark_comp }}%
                    </h3>

                    <p class="dustin dontstandso has-text-centered description">
                      {{ metric.less_is_more ? 'Less' : 'More' }}
                    </p>
                  </div>

                  <div
                    :style="{width: (metric.relative_benchmark_comp / 100) * 90}"
                    v-bind:class="`rectangle ${metric.esgissue_slug}-bar`"
                  >
                  </div><!-- rectangle-->
              </div><!-- barbox -->
            </a>
          </div>

          <!-- right side portfolio b -->

          <div class="column nopadding is-one-quarter has-text-left">
            <div class="verticalline"></div>

              <a
                v-if="!metric.better_than_benchmark"
                target="_blank" rel="noreferrer noopener"
                v-bind:href="`/impact-report-attribution/${metric.attribution_id}/${portfolio.slug}${benchmark.name ? ':' + benchmark.slug : ''}`"
              >
                <div class="barbox barbox-right">
                  <div :style="{width: (metric.relative_benchmark_comp / 100) * 90}" v-bind:class="`rectangle ${metric.esgissue_slug}-bar`"></div><!-- rectangle-->
                <div>
                <h3 class="dustin preheader dontstandso smaller-line-height">
                  {{ metric.relative_benchmark_comp }}%
                </h3>
                <p class="dustin dontstandso has-text-centered description">
                  {{ metric.less_is_more ? 'Less' : 'More' }}
                </p>
                </div>
              </div><!-- barbox -->
            </a>
          </div>
        </div><!-- columns for each metric-->
  </section>
</div><!-- page -->
</template>

<script>

  import eventBus from '@frontend/shared/EventBus.js';

  export default {
    components: {
    },
    data () {
      return {
        ready: false,
        impactReport: {},

      }
    },
    props: {
      portfolio: Object,
      benchmark: Object,
    },
    created: async function() {
      this.ready = true;
      eventBus.$emit('InstitutionalReport:page-rendered', this.$options.name);
    },
    mounted () {
    },
    computed: {
      esgScores: function() {
        return Object.keys(this.reportMetricsByEsgIssue).map((esgIssueKey) => {
          const esgIssue = this.reportMetricsByEsgIssue[esgIssueKey]
          return esgIssue[0].mean_weighted_numbers.toFixed(1)
        })
      },
      realScore: function() {
        const score = (parseFloat(this.esgScores[0]) + parseFloat(this.esgScores[1]) + parseFloat(this.esgScores[2]))/3.0
        if(score > 8.571) {
          return 'AAA'
        }
        else if(score > 7.143) {
          return 'AA'
        }
        else if(score > 5.714) {
          return 'A'
        }
        else if(score > 4.286) {
          return 'BBB'
        }
        else if(score > 2.857) {
          return 'BB'
        } else if(score > 1.429) {
          return 'B'
        } else {
          return 'CCC'
        }
      },
      reportMetricsByEsgIssue: function() {
        // Copy-paste from YourImpactPreferences.vue
        if (this.portfolio.msci_report) {
          
          console.log("DSJFLSDJFKLSJFIOEFFFFFFGERSH",this.portfolio.msci_report.report.metrics.reduce((acc, itm) => {
            if (!(itm.esgissue_slug in acc)) {
              acc[itm.esgissue_slug] = [];
            }
            acc[itm.esgissue_slug].push(itm);
            return acc;
          }, {}))
          return this.portfolio.msci_report.report.metrics.reduce((acc, itm) => {
            if (!(itm.esgissue_slug in acc)) {
              acc[itm.esgissue_slug] = [];
            }
            acc[itm.esgissue_slug].push(itm);
            return acc;
          }, {});
        }
        else {
          return {};
        }
      }
    },
    methods: {
      getChartPctMargin: function(pct, slug) {
        // When the bars on the chart are too short, the names of each column can wind up overlapping the percentage,
        // so this is a way of ensuring they don't overlap. It will be a problem if we change fonts or something
        // but it much simpler than trying to measure the text labels.

        const barWidth = this.getPxForPct(pct, false, true);
        const offsets = {
          'health': 45,
          'environment': 70,
          'human-rights': 75,
          'equal-opportunity': 90,
          'accountability': 75,
        }
        if (barWidth < offsets[slug]) {
          return `margin-left: ${offsets[slug] - barWidth}px;`
        }
      },
      getPxForPct: function(pct, isTop, raw) {
        console.log(pct)
        let px;
        if (pct > 50) {
          if (isTop) {
            px = (pct - 50) / 100 * 120;
          }
          else {
            px = 120;
          }
        }
        else {
          if (isTop) {
            return '';
          }
          else {
            px = pct / 100 * 240;
          }
        }

        if (raw) {
          return px;
        }
        else {
          return `width: ${px}px`;
        }
      },
    }
  }

</script>

<style lang="scss" scoped>
  .tableofcontents {
    padding: 6rem;
  }
  .small {
    max-width: 600px;
  }

  .verticalline {
    position: absolute;
    width: 1px;
    height: 170px;
    /* border-left: 1px solid var(--black-95); */
    background-color: var(----black-95);
    margin-top: -20px;
  }

  .metric-section:last-of-type .columns:last-child .verticalline {
    border-color: transparent;
  }

  .adjust-pixels-left {
    margin-left: 175px !important;
  }
  .adjust-pixels-right {

  }

  .esgissue-label-inner-text {
    margin-top: .5rem;
    position: absolute;
  }
  .rectangle {
    max-width: 120px !important;
    height: 35px !important;
    margin-right: 2px;
    margin-left: 1px;

    .barbox-left & {
      margin-right: 0;
    }
  }

  .graphic {
    background-color: transparent !important;
    margin: auto;
    // margin-top: -10em; remove for msci report
    width: 310px;
    transform: rotate(-45deg);
    padding: .5rem;
    white-space: nowrap;
  }

      /* layout for metric boxes */

      .metricbox {
          height: 6rem;
          border-radius: 5px;
          border: solid 1px #d8d8d8;
          margin: 0.15rem;
          padding: .25rem;
      }

      /* colors tied to issue slugs */
      .environment-border {
          border-color: #158f60;
          color: #158f60 !important;
      }

      .equal-opportunity-border {
          border-color: #da8f3e;
          color: #da8f3e !important;
      }

      .human-rights-border {
          border-color: #7f4b92;
          color: #7f4b92 !important;
      }

      .health-border {
          border-color: #b85255;
          color: #b85255 !important;
      }
      .accountability-border {
          border-color: #4994c4;
          color: #4994c4 !important;
      }
      .environment-color {
          color: #158f60;
          background: #158f60;
          border-color: #158f60;
      }

      .equal-opportunity-color {
          color: #da8f3e;
          background: #da8f3e;
          border-color: #da8f3e;
      }

      .human-rights-color {
          color: #7f4b92;
          background: #7f4b92;
          border-color: #7f4b92;
      }

      .health-color {
          color: #b85255;
          background: #b85255;
          border-color: #b85255;
      }
      .accountability-color {
          color: #4994c4;
          background: #4994c4;
          border-color: #4994c4;
      }



    /*
      Create Flip Animation for cards, which show description.
    */


        /* The flip card container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
        .flip-card {
        background-color: transparent;
        perspective: 1000px; /* Remove this if you don't want the 3D effect */
        }

        /* This container is needed to position the front and back side */
        .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.2s;
        transform-style: preserve-3d;
        }

        /* Do an horizontal flip when you move the mouse over the flip box container */
        .flip-card:hover .flip-card-inner {
        transform: rotateY(180deg);
        }

        /* Position the front and back side */
        .flip-card-front, .flip-card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        transform-style: preserve-3d;
        }

      .flip-card-back {
        transform: rotateY(180deg);
      }
      .metricbox * {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          line-height: 1;
      }
      .nopadding {
        padding: 0em;
      }
      .barbox-right > * {
        margin-right: auto;
      }
      .msci-circle {
        font-size: 2rem;
        width: 6rem;
        height: 6rem;

        background-color: #0dbc79;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 2px solid black;
      }
      .tabs.is-toggle li.is-active a {
        background-color: grey !important;
        border-color: grey !important;
      }
</style>
